module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Fc-Gc-Hc-Ia-Ge.f41bde82.png";